export class ScaleSearchRequest {
    constructor(public nameFilter?: string,
                public dataTypeIds?: number[]) {
    }
}
